module.exports = __webpack_public_path__ + "static/media/561.f9a78d75.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/vehicleDetail/images/561.png
// module id = 771
// module chunks = 0